module.exports = __webpack_public_path__ + "img/emo_40.4e105581.gif";